export default __webpack_public_path__ + "static/media/machu_picchu-aguas_calientes.42fb1c88.jpg";